import { object, string } from "yup";

export const forgotPasswordPayloadValidation = object().shape({
  email: string().trim().email()
    .required(),
});
